import { SurveyAnswerValue, SurveyMultiAnswerValue, SurveyQuestion } from "../interface"
import { AnswerType } from "../constants"

export const isValidAnswer = (
    question: SurveyQuestion,
    answerValue?: SurveyAnswerValue | SurveyMultiAnswerValue
) => {
    if (question.type === AnswerType.choices && answerValue) {
        const selectedCount = Object.values(answerValue as SurveyMultiAnswerValue).filter(
            (entry) => entry.value
        ).length
        const { min_count, max_count } = question.validations

        if (min_count !== undefined && selectedCount < min_count) {
            return false
        }

        if (max_count !== undefined && selectedCount > max_count) {
            return false
        }
    }
    return true
}
